// 创建进度条组件
class InventoryProgressBar extends HTMLElement {
  constructor() {
    super();

    //   this.currencySymbol = ''

    //   this.startAt = ''
    //   this.endAt = ''

    //   this.gid = ''
    //   this.vid = ''
    //   this.code = ''

    //   this.variantId = ''

    //   this.discount = {}

    //   this.dayNum = 7 // 7 day inner show code

    //   this.timer = null
    //   this.timerCode = null

    this.init()
  }

  init() {
    this.initVariantInfo()
    //this.bindEvent()
  }

  // 初始化变体信息，
  initVariantInfo() {
    const variantFields = $('#product-variant-fields')
    if (variantFields[0]?.innerHTML) {
      const metafieldsCustoms = JSON.parse(variantFields[0].innerHTML)
      const product_inventory_countdown = metafieldsCustoms?.metafieldsCustoms?.variants_discounts_and_marketing?.product_inventory_countdown;
      const product_marketing_label = metafieldsCustoms?.metafieldsCustoms?.variants_discounts_and_marketing?.product_marketing_label;
      //document.querySelector('.progress-bars-container').innerHTML = product_inventory_countdown?.warning_tip;
      // 判断是否显示进度条
      console.log(product_inventory_countdown)
      console.log(product_marketing_label)
      if (product_inventory_countdown) {
        const current_inventory_num = product_inventory_countdown.current_inventory_num;
        const total_inventory_num = product_inventory_countdown.total_inventory_num;
        const warning_inventory_num = product_inventory_countdown.warning_inventory_num;
        const isShowProgressBar = current_inventory_num > 0 && current_inventory_num <= warning_inventory_num && current_inventory_num < total_inventory_num;
        if (isShowProgressBar) {
          console.log('显示进度条')
          document.querySelector('.progress-containers').style.display = 'block';
          document.querySelector('.progress-warning-tip').innerHTML = product_inventory_countdown.warning_tip;
          document.querySelector('.progress-bars-text').innerHTML = 'Only ' + Math.floor(current_inventory_num / total_inventory_num * 100) + '% Left';
        } else {
          document.querySelector('.progress-containers').style.display = 'none';
          document.querySelector('.progress-warning-tip').innerHTML = '';
          document.querySelector('.progress-bars-text').innerHTML = '';
        }

        // 计算进度条进度
        if (isShowProgressBar) {
          const inventory_progress = Math.floor(current_inventory_num / total_inventory_num * 100);
          console.log('计算出的进度:', inventory_progress);
          const progressFill = document.querySelector('.progress-bars-fill');
          if (progressFill) {
            progressFill.style.width = inventory_progress + '%';
          }
        }
      }
    }
  }

}

customElements.define('inventory-progress-bar', InventoryProgressBar);